import React from 'react';
import PropTypes from 'prop-types';
import { Text, View, TouchableOpacity } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { styles } from './Styles';
import { moderateScale } from 'react-native-size-matters';

const GoalCardWithFullDescription = ({
    t, icon, settingIconStyle, onPress, title, subtitle, description, isActive, withArrow = true, containerStyle = {}, descriptionTextStyle = {}, headingTextStyle = {}, subtitleStyle = {}
}) => (
    <View
        style={[styles.cardContainer, isActive && styles.activeCardContainer, containerStyle]}>
            <View style={[styles.cardHeader, { alignItems: 'center'}]}>
                {icon &&
                    <View style={styles.bodyGroupIconContainer}>
                        {icon}
                    </View>
                }
                <View style={[styles.headerContainer, !subtitle && { alignSelf: 'center' }]}>
                    {subtitle &&
                        <View style={styles.subtitleInnerContainer}>
                            <Text style={[styles.subtitle, subtitleStyle]}>{subtitle.toUpperCase()}</Text>
                        </View>
                    }
                    <View style={styles.titleContainer}>
                        <Text style={[styles.title, isActive && styles.activeTitle, headingTextStyle]}>{title.toUpperCase()}</Text>
                    </View>
                </View>
            </View>
            <View>
                {description &&
                        <Text style={[styles.description, descriptionTextStyle]}>{description}</Text>
                }
            </View>
    </View>
    );

GoalCardWithFullDescription.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.element,
    onPress: PropTypes.func.isRequired,
    isMore: PropTypes.bool,
};

export default GoalCardWithFullDescription;
